module.exports = __webpack_public_path__ + "components/weather-icon/static/nightriskshowers-03fac22a337e560db72423fe393eac41.svg";